import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const FeesChargesPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">利用料・配送料について</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          {/* 利用料 Section */}
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">利用料</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">会員登録・月額料金</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ¥0<br/>会員登録や月額料金などの利用料は発生いたしません。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">販売手数料</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  販売価格（商品代金）の5%
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">購入手数料</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  無料
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">真贋鑑定料</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ¥220<br/>※鑑定不能の場合には鑑定料は発生せず取引キャンセルとなります。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">売上金の振込手数料</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ¥550<br/>振込申請後に運営から指定口座へ入金する際に発生する手数料です。<br/>※売上金から上記手数料を引いた額が振り込まれます。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">キャンセル料</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  商品代金の10%<br/>取引成立後に自己都合、発送期限切れ等で取引キャンセルとなった場合の手数料です。
                </div>
              </div>
            </div>
          </div>
          
          {/* 配送料 Section */}
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">配送料</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">出品者からDONDONへの配送料</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  DONDONまでの配送料は出品者様負担となります。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">DONDONから購入者への配送料</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  <span>・未開封ボックス　全国一律：¥990<br/>・シングルカード　全国一律：¥550<br/></span>
                  <span>ヤマト運輸で配送いたします。<br/>※配送先住所のご変更（転送）には、別途着払いの送料が発生する場合があります。</span>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">商品が鑑定基準を満たさなかった場合の出品者への返送料</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  商品が当社の定める基準を満たしていない場合に、出品者様へ返送する際に発生する手数料です。<br/>
                  返送は一律着払い（出品者様ご負担）にて行います。<br/>
                  ※返送後、商品をお受け取りいただけずDONDONに再び商品が戻ってきた場合は、事務局よりご連絡いたしますので、必ずご返信をお願いいたします。<br/>
                  ※ご連絡から2週間以内にご返信がない場合は、商品を処分させていただくことがございます。<br/>
                  ※返送後のお受け取り拒否が継続する場合、事務局の判断によりアカウント停止などの措置を取らせていただく場合がございます。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default FeesChargesPage;